module.exports = __webpack_public_path__ + "img/全部.f49f4311.svg";